import React, { createRef } from "react";
import {
  Select,
  Checkbox,
  Row,
  Col,
  Button,
  Space,
  DatePicker,
  Dropdown,
  Modal,
  Image,
  Tooltip,
  Input,
} from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import { Link } from "react-router-dom";
import withRouter from "../withRouter";
import PythonMessageAlert from "./PythonMessageAlert";
import conf from "../config";
import JourneyMonitoringReportStore from "../store/journeyMonitoringReportStore";
import CompanyAutocomplete from "./CompanyAutocomplete";
import ListTable from "./ListTable";
import VehicleStore from "../store/VehicleStore";
import dayjs from "dayjs";
import { decode as base64_decode } from "base-64";
import Cookies from "js-cookie";
import DeviceGroupsForVehicles from "./DeviceGroupsForVehicles";
import refreshIcon from "../assets/images/NewDesign/refreshicon.svg";
import downloadIcon from "../assets/images/NewDesign/Download.svg";
import PDF from "../assets/images/NewDesign/PDF.svg";
import Excel from "../assets/images/NewDesign/Excel.svg";
import MapForVehiclePosition from "./MapForVehiclePosition";

const { RangePicker } = DatePicker;
const { Option } = Select;
class JourneyMonitoringReportList extends React.Component {
  constructor(props, context) {
    super(props);
    this.handleTableChange = this.handleTableChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.JourneyMonitoringReportStore = new JourneyMonitoringReportStore();
    this.vehicleStore = new VehicleStore();
    this.pythonMessageRef = createRef();

    this.state = {
      loading: false,
      exportLoading: false,
      pageSize: 50,
      currentPage: 1,
      selectedVehicles: [],
      selectAllVehicles: false,
      selectedDriver: [],
      Notdriver: false,
      selectAllDrivers: false,
      companyId: "",
      modalVisible: false,
      column: "",
      filter: "",
      showMonthPopup: false,
      Notcompany: false,
      Notasset: false,
      fromDate: dayjs().format("YYYY-MM-DD 00:00:00"),
      toDate: dayjs().format("YYYY-MM-DD 23:59:59"),
      pythonReportMessage: false,
      reportmessage: "",
      Notdate: false,
      journeyNum: "",
      vehicleObj: false,
      heading: "",
      selectedColumns: [
        {
          // title: "Asset Name",
          title: context.translate("_JOURNEY_NUMBER_"),
          dataIndex: "journeyNum",
          key: "journeyNum",
          ellipsis: {
            showTitle: true,
          },
          width:110
          // fixed: 'left',
        },
        {
          // title: "Driver Name",
          title: context.translate(
            "_JOURNEY_OFFICE_"
          ),
          dataIndex: "journeyDeskName",
          key: "journeyDeskName",
          ellipsis: {
            showTitle: true,
          },
          width:100
        },
        {
          title: context.translate("_REG_NO_"),
          dataIndex: "vehicleNo",
          key: "vehicleNo",
          width:70
          // render: (_, record) => {
          //     if (!record.times) return " ";

          //     const date = dayjs.utc(Number(record.times)); // Force UTC

          //     return date.isValid()
          //         ? date.format("DD-MM-YYYY hh:mm:ss A")
          //         : " ";
          // }
        },
        {
          // title: "Start Odometer",
          title: context.translate("_VEHICLE_TYPE_"),
          dataIndex: "vehicleTypeNew",
          key: "vehicleTypeNew",
          ellipsis: {
            showTitle: true,
          },
          width:80
          // render: (value, obj) => {
          //   return (
          //     <Link
          //       onClick={async (e) => {
          //         await this.setState({
          //           vehicleObj: { ...obj },
          //           heading: this.context.translate("_LOCATION_ON_MAP_"),
          //         });
          //       }}
          //     >
          //       {value}
          //     </Link>
          //   );
          // },
        },
        {
          // title: "Stop Odometer",
          title: context.translate("_FLEET_DASHBORD_VEHICLE_INFORMATION_DRIVERNAME_"),
          dataIndex: "drvierName",
          key: "drvierName",
          ellipsis: {
            showTitle: true,
          },
          width:80
        },
        {
          // title: "Amount",
          title: context.translate("_NO_OF_STOPS_"),
          dataIndex: "noOfStops",
          key: "noOfStops",
          ellipsis: {
            showTitle: true,
          },
           width:80
        },
        {
          // title: "Fuel",
          title: context.translate("_NO_OF_PASSENGERS_"),
          dataIndex: "coPassengers",
          key: "coPassengers",
          ellipsis: {
            showTitle: true,
          },
           width:80
        },
        {
          // title: "Entered Odometer",
          title: context.translate("_START_LOCATION_"),
          dataIndex: "actualStartLocation",
          key: "actualStartLocation",
          ellipsis: {
            showTitle: true,
          },
           width:80
        },
        {
          // title: "Entered Odometer",
          title: context.translate("_FLEET_START_TIME_"),
          dataIndex: "actualStartTime",
          key: "actualStartTime",
          ellipsis: {
            showTitle: true,
          },
           width:80,
            render: (value) => {
                if (!value) return null;

                return dayjs.utc(value).format("DD-MM-YYYY hh:mm:ss A");
            },
        },
        {
          // title: "Entered Odometer",
          title: context.translate("_PLANNED_LOCATION_"),
          dataIndex: "destination",
          key: "destination",
          ellipsis: {
            showTitle: true,
          },
           width:80
        },
        {
          // title: "Entered Odometer",
          title: context.translate("_TIME_TAKEN_"),
          dataIndex: "timeTaken",
          key: "timeTaken",
          ellipsis: {
            showTitle: true,
          },
           width:80
        },
        {
          // title: "Entered Odometer",
          title: context.translate("_FLEET_RULESELECTORDETAIL_RULE13_TITLE_"),
          dataIndex: "distanceTravelled",
          key: "distanceTravelled",
          ellipsis: {
            showTitle: true,
          },
           width:80
        },
        {
          // title: "Entered Odometer",
          title: context.translate("_ARRIVAL_LOC_"),
          dataIndex: "actualEndLocation",
          key: "actualEndLocation",
          ellipsis: {
            showTitle: true,
          },
           width:80
        },
        {
          // title: "Entered Odometer",
          title: context.translate("_FLEET_REPORTS_STOPREPORT_ARRIVALTIME_"),
          dataIndex: "actualEndTime",
          key: "actualEndTime",
          ellipsis: {
            showTitle: true,
          },
           width:80,
           render: (value) => {
                if (!value) return null;
                return dayjs.utc(value).format("DD-MM-YYYY hh:mm:ss A");
            },
        },
        {
          // title: "Entered Odometer",
          title: context.translate("_TOTAL_DISTANCE_COVERED_"),
          dataIndex: "distanceTravelled1",
          key: "distanceTravelled1",
          ellipsis: {
            showTitle: true,
          },
           width:80,
        },
        {
          // title: "Entered Odometer",
          title: context.translate("_JOURNEY_STATUS_"),
          dataIndex: "status",
          key: "status",
          ellipsis: {
            showTitle: true,
          },
           width:80
        },



      ],
    };
    this.ExportMenuProps = {
      items: [
        {
          label: (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
            >
              {" "}
              <Image
                style={{ height: "18px", width: "18px", borderRadius: "0px" }}
                src={Excel}
              ></Image>
              {context.translate("_EXPORT_AS_EXCEL_")}
            </div>
          ),
          key: "excel",
        },
        {
          label: (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
            >
              {" "}
              <Image
                style={{ height: "18px", width: "18px", borderRadius: "0px" }}
                src={PDF}
              ></Image>
              {context.translate("_EXPORT_AS_PDF_")}
            </div>
          ),
          key: "pdf",
        },
      ],
      onClick: async (val) => {
        let result = [];
        console.log(val);
        if (true) {
          this.state.selectedColumns.map((obj) => result.push(obj.dataIndex));

          var getData = {
            companyId: this.state.companyId,
            vehicleId: this.state.selectedVehicles,
            DriverId: this.state.selectedDriver,
            fromDate: this.state.fromDate,
            toDate: this.state.toDate,
            colList: result.toString(),
            userId: JSON.parse(base64_decode(Cookies.get("data"))).userId,
          };

          this.setState({ exportLoading: true });
          try {
            if (val.key == "excel") {
              await this.JourneyMonitoringReportStore.exportExcel(getData);
              const isSuccess =
                this.JourneyMonitoringReportStore?.pythonReportMessage === true;
              const isError =
                this.JourneyMonitoringReportStore?.pythonReportErrorMessage;

              if (isSuccess || isError) {
                await this.setState({
                  reportmessage: isSuccess ? "success" : "error",
                });
                await this.triggerReport();
              }
            }

            if (val.key == "pdf") {
              await this.JourneyMonitoringReportStore.exportpdf(getData);
              const isSuccess =
                this.JourneyMonitoringReportStore?.pythonReportMessage === true;
              const isError =
                this.JourneyMonitoringReportStore?.pythonReportErrorMessage;

              if (isSuccess || isError) {
                await this.setState({
                  reportmessage: isSuccess ? "success" : "error",
                });
                await this.triggerReport();
              }
            }
          } finally {
            this.setState({ exportLoading: false });
          }
        }
      },
    };
    this.newColumns = [...this.state.selectedColumns];
  }
  async componentDidMount() {
    // await this.fuelRefilledReportStore.loadData({ offset: 0, limit: 20 });

    this.setState({ pageSize: 50 });
    if (Number(this.props.getUserData().isadmin) !== -1) {
      let companyId = this.props.getUserData().userCompanyId;

      this.setState({ companyId: companyId });
      this.handleChange({ value: companyId });
    }

    await this.setState({ column: this.state.selectedColumns });
  }

  async componentDidUpdate(prevProps, prevState) {
    if (this.state.vehicleObj !== prevState.vehicleObj) {
      // console.log("ilocasd");
      setTimeout(() => {
        window.dispatchEvent(new Event("resize"));
      });
    }
  }

  async handleChange(comp) {
    await this.setState({ Notcompany: false });
    console.log(this.state.selectedVehicles);
    this.setState({ selectedVehicles: [], selectAllVehicles: false });
    this.setState({ selectedDriver: [], selectAllDrivers: false });

    await this.setState({ companyId: comp?.value });
    await this.vehicleStore.getVehiclesCompanyId(comp?.value);

    await this.handleSearch();
    //  console.log(data,"sdcd")
  }

  async handleSearch() {
    this.setState({ Notasset: false });
    // await this.fuelRefilledReportStore.loadData({
    //   offset: (this.state.currentPage - 1) * this.state.pageSize,
    //   limit: this.state.pageSize,
    //   companyId: this.state.companyId,
    //   pageNo: this.state.currentPage,
    // });
    await this.setState({ loadData: 1 });
  }

  async handleTableChange(pagination, filters, sorter) {
    console.log(pagination);
    await this.setState({
      currentPage: pagination.current,
      pageSize: pagination.pageSize,
    });
    // this.handleSearch();
    await this.showData();
  }

  vehicleSelect = async (val) => {
    console.log(val);
    await this.setState({ selectedVehicles: val });
  };

  driverSelect = async (val) => {
    console.log(val);
    await this.setState({ selectedDriver: val });
  };
  showData = async () => {
    console.log("This is the inside")
    this.setState({ loading: true });
    if (!this.state.companyId) {
      this.setState({ Notcompany: true });
    } else {
      this.setState({ Notcompany: false });
    }
    if (this.state.selectedVehicles.length === 0) {
      this.setState({ Notasset: true });
    } else {
      this.setState({ Notasset: false });
    }
    if (!this.state.fromDate) {
      this.setState({ Notdate: true });
    } else {
      this.setState({ Notdate: false });
    }

    if (
      this.state.companyId &&
      this.state.selectedVehicles.length > 0 &&
      this.state.fromDate &&
      this.state.toDate
    ) {
      // this.setState({mandatory:false})
      this.setState({ Notcompany: false, Notasset: false, Notdriver: false });
      if (this.checkFromDate(this.state.fromdateStdTime)) {
        await this.JourneyMonitoringReportStore.loadData({
          offset: (this.state.currentPage - 1) * this.state.pageSize,
          limit: this.state.pageSize,
          companyId: this.state.companyId,
          vehicleId: this.state.selectedVehicles,
          fromDate: this.state.fromDate,
          toDate: this.state.toDate,
          pageNo: this.state.currentPage,
          journeyNum: this.state.journeyNum,
        });
        this.setState({ loading: true });
      }
    }
  };

  handleCheckboxChange = async (column) => {
    console.log(column);
    if (this.state.selectedColumns.some((c) => c.key === column.key)) {
      const filtered = this.state.selectedColumns.filter(
        (c) => c.key !== column.key
      );
      console.log(filtered);
      await this.setState({
        selectedColumns: filtered,
      });
      await this.setState({ column: filtered });
      // await  this.updateVisibleColumns();
    } else {
      console.log("adsf");
      await this.setState({
        selectedColumns: [...this.state.selectedColumns, column],
        column: [...this.state.selectedColumns, column],
      });
      // await  this.updateVisibleColumns();
    }
  };
  addMonths = (date, months) => {
    // date.setMonth(date.getMonth() + months);
    // date = date + months;
    var indx = dayjs().month() + -6;
    // return date.format("YYYY-MM-DD HH:mm:ss");
    return dayjs().month(indx);
  };

  checkFromDate(dates) {
    //  var fromDate = dates.format("YYYY-MM-DD HH:mm:ss");
    var fromDate = dates;
    var pdate = this.addMonths();
    if (pdate > fromDate) {
      //  Ext.Msg.show({
      //      title: fleet.Language.get('_FLEET_ALERT_'),
      //      msg: fleet.Language.get('_REPORTS_PRIOR_CONTACT_ADMINISTRATOR_'),
      //      buttons: Ext.Msg.OK,
      //  });
      this.setState({ showMonthPopup: true });
      return false;
    } else {
      return true;
    }
  }
  onDateTimeChange = (dates) => {
    if (dates) {
      const format = "YYYY-MM-DD HH:mm:ss";
      this.setState({
        fromdateStdTime: dates[0],
        fromDate: dates[0].format(format),
        toDate: dates[1].format(format),
      });
    } else {
      this.setState({ fromDate: "", toDate: "" });
    }
  };

  handleAllSelectVehicles = async () => {
    if (this.state.selectAllVehicles) {
      const allVehicles = this.vehicleStore?.getVehiclesUsingCompanyId.map(
        (val) => {
          return val.vehicleId;
        }
      );
      await this.setState({ selectedVehicles: allVehicles });
    } else {
      await this.setState({ selectedVehicles: [] });
    }
  };

  handleSelectAllDrivers = async (e) => {
    if (this.state.selectAllDrivers) {
      const allDrivers = this.JourneyMonitoringReportStore?.getDrivers.map((val) => {
        return val.driverId;
      });
      await this.setState({ selectedDriver: allDrivers });
    } else {
      await this.setState({ selectedDriver: [] });
    }
  };
  refreshList = async () => {
    await this.setState({ loading: false, current: 1, currentPage: 1 });
    await this.showData();
  };
  triggerReport = () => {
    this.pythonMessageRef.current.show(); // show the modal
  };
  render() {
    return (
      <>
        <div className="listHeader">
          <Row className="listInputRow">
            <Col span={20}>
              <Space>
                <CompanyAutocomplete
                  allowClear={true}
                  className="searchInput"
                  onChange={this.handleChange}
                  style={{ width: 150 }}
                  // style={companyInputStyle}
                  status={this.state.Notcompany ? "error" : false}
                />

                {this.props.getUserData().isadmin === 1 && (
                  <DeviceGroupsForVehicles
                    vehicleStore={this.vehicleStore}
                    setLoadDta={() => this.setState({ loadData: 1 })}
                    resetVehicles={() =>
                      this.setState({
                        selectedVehicles: [],
                        selectAllVehicles: false,
                      })
                    }
                  />
                )}
                <Checkbox
                  checked={this.state.selectAllVehicles}
                  onChange={async (e) => {
                    await this.setState({
                      selectAllVehicles: e.target.checked,
                    });
                    await this.handleAllSelectVehicles();
                  }}
                />
                {this.context.translate("_ALL_")}

                <Select
                  className="searchInput"
                  maxTagCount="responsive"
                  value={this.state.selectedVehicles}
                  onChange={(val) => {
                    this.setState({ selectedVehicles: val });
                    if (
                      this.vehicleStore?.getVehiclesUsingCompanyId?.length >
                      val.length
                    ) {
                      this.setState({ selectAllVehicles: false });
                    } else {
                      this.setState({ selectAllVehicles: true });
                    }
                  }}
                  style={{ width: 150 }}
                  showSearch
                  status={this.state.Notasset ? "error" : false}
                  mode="multiple"
                  placeholder={this.context.translate(
                    "_FLEET_DASHBORD_VEHICLE_VIEWICON_TITLE_"
                  )}
                  filterOption={(inputValue, option) => {
                    if (option.children) {
                      return (
                        option.children
                          .toLowerCase()
                          .indexOf(inputValue.toLowerCase()) >= 0
                      );
                    }
                  }}
                >
                  {this.vehicleStore?.getVehiclesUsingCompanyId?.map((val) => {
                    return (
                      <Option value={val.vehicleId}>{val.vehicleNo}</Option>
                    );
                  })}
                </Select>
                {/* <Checkbox
                  checked={this.state.selectAllDrivers}
                  onChange={async (e) => {
                    await this.setState({
                      selectAllDrivers: e.target.checked,
                    });
                    console.log(e.target.checked);
                    await this.handleSelectAllDrivers();
                  }}
                /> */}
                {/* All */}
                {/* {this.context.translate("_ALL_")} */}
                {/* <Select
                  onSearch={this.handleSearch}
                  className="searchInput"
                  value={this.state.selectedDriver}
                  mode="multiple"
                  maxTagCount="responsive"
                  onChange={(val) => {
                    this.setState({ selectedDriver: val });
                    if (
                      this.fuelRefilledReportStore?.getDrivers.length > val.length
                    ) {
                      this.setState({ selectAllDrivers: false });
                    } else {
                      this.setState({ selectAllDrivers: true });
                    }
                  }}
                  // fieldNames={{ label: "name", value: "driverId" }}
                  // placeholder="Driver name"
                  placeholder={this.context.translate(
                    "_FLEET_DASHBORD_VEHICLE_INFORMATION_DRIVERNAME_"
                  )}
                  optionFilterProp="children"
                  // options={this.fuelRefilledReportStore?.getDrivers}
                  style={{ width: 160 }}
                  status={this.state.Notdriver ? "error" : false}
                  filterOption={(inputValue, option) => {
                    if (option.children) {
                      return (
                        option.children
                          .toLowerCase()
                          .indexOf(inputValue.toLowerCase()) >= 0
                      );
                    }
                  }}
                >
                  {this.fuelRefilledReportStore?.getDrivers?.map((val) => {
                    return <Option value={val.driverId}>{val.name}</Option>;
                  })}
                </Select> */}

                <Input
                  className="searchInput"
                  placeholder={this.context.translate("_JOURNEY_NUMBER_")}
                  value={this.state.journeyNum}
                  onChange={(e) =>
                    this.setState({ journeyNum: e.target.value })
                  }
                  style={{ width: 150, borderRadius: "25px" }}
                  allowClear
                />

                <RangePicker
                  status={this.state.Notdate ? "error" : false}
                  placeholder={["From Datetime", "To Datetime"]}
                  format="DD-MM-YYYY hh:mmA"
                  style={{ width: 400, borderRadius: "25px" }}
                  onChange={(val) => {
                    this.onDateTimeChange(val);
                  }}
                  //  disabledDate={(current) => { 
                  //     return current && current > dayjs();
                  //   }}
                  showTime={{
                    format: "h:mmA",
                    defaultValue: [
                      dayjs().startOf("day"),
                      dayjs().endOf("day"),
                    ],
                  }}
                  defaultValue={[dayjs().startOf("day"), dayjs().endOf("day")]}
                />
                <Button
                  type="primary"
                  onClick={async () => {
                    await this.setState({ currentPage: 1, pageSize: 50 });
                    await this.showData();
                  }}
                >
                  {/* Show */}
                  {this.context.translate("_FLEET_SHOW_BTN_")}
                </Button>
                <Button onClick={() => this.setState({ modalVisible: true })}>
                  {this.context.translate("_COLUMNS_")}
                </Button>
              </Space>
            </Col>
            <Col
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
              span={4}
            >
              <Space>
                <Tooltip
                  title={this.context.translate("_REFRESH_")}
                  placement="bottom"
                >
                  <Image
                    style={{
                      height: 18,
                      marginInlineEnd: "20px",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                    src={refreshIcon}
                    onClick={() => this.refreshList()}
                  ></Image>
                </Tooltip>
                <Button
                  className={`downloadExcelButton ${this.state.exportLoading ? "downloadExcelButtonLoading" : ""
                    }`}
                  loading={this.state.exportLoading}
                  disabled={
                    this.JourneyMonitoringReportStore?.JourneymonitorReport?.length > 0
                      ? false
                      : true
                  }
                >
                  <Dropdown
                    overlayClassName="export-dropdown"
                    menu={this.ExportMenuProps}
                  >
                    <Image
                      style={{
                        height: 18,
                        alignItems: "center",
                        marginInlineEnd: "30px",
                      }}
                      src={downloadIcon}
                    ></Image>
                  </Dropdown>
                </Button>
              </Space>
            </Col>
          </Row>

          <Modal
            open={this.state.modalVisible}
            width={300}
            // title="Select Columns"
            title={this.context.translate("_SELECT_COLUMNS_")}
            onCancel={() => this.setState({ modalVisible: false })}
            onOk={() => {
              this.setState({ modalVisible: false });
            }}
            footer={null}
          >
            <div style={{ maxHeight: "400px", overflowY: "auto" }}>
              {console.log(this.newColumns, "Df")}
              {this.newColumns.map((column, v) => {
                return (
                  <Row key={v}>
                    <Col>
                      <Checkbox
                        onChange={() => this.handleCheckboxChange(column)}
                        checked={this.state.selectedColumns.some(
                          (c) => c.key === column.key
                        )}
                      >
                        {column.title}
                      </Checkbox>
                    </Col>
                  </Row>
                );
              })}
            </div>
          </Modal>

          <ListTable
            currentPage={this.state.currentPage}
            pageSize={this.state.pageSize}
            total={this.JourneyMonitoringReportStore?.total}
            columns={this.state.column}
            dataSource={this.JourneyMonitoringReportStore?.JourneymonitorReport}
            loading={this.JourneyMonitoringReportStore?.loading}
            onChange={this.handleTableChange}
            {...(conf.currentFlavor === "nodeui" && {
              showSizeChanger: false,
              moreClass: "gridNum",
            })}
          // pagination={{
          //   pageSize: this.state.pageSize,
          //   //  current:this.state.pageNo
          //   total:this.fuelRefilledReportStore?.total || 0

          // }}
          // scroll={{
          //   // y: this.state.clientHeight-240,
          //   x: 100,
          // }}
          />

          <Modal
            width={350}
            className="alert-model"
            title={
              <div>
                {" "}
                <i
                  style={{ color: "red", fontSize: "18px", marginRight: "5px" }}
                  class="bi bi-exclamation-triangle"
                ></i>{" "}
                {/* Alert */}
                {this.context.translate("_FLEET_ALERT_")}
              </div>
            }
            open={this.state.showMonthPopup}
            onOk={() => this.setState({ showMonthPopup: false })}
            onCancel={() => this.setState({ showMonthPopup: false })}
            footer={false}
          >
            {/* For reports prior to 6 months please contact administrator */}
            {this.context.translate("_REPORTS_PRIOR_CONTACT_ADMINISTRATOR_")}
          </Modal>
        </div>
        {
          <div>
            <PythonMessageAlert
              ref={this.pythonMessageRef}
              message={this.state.reportmessage}
            />
          </div>
        }

        {this.state.vehicleObj && (
          <MapForVehiclePosition
            vehicleObj={this.state.vehicleObj}
            heading={this.state.heading}
            closeMapModal={(resp) => {
              this.setState({ vehicleObj: resp });
            }}
          />
        )}
      </>
    );
  }
}
JourneyMonitoringReportList.contextType = StoreContext;
export default observer(withRouter(JourneyMonitoringReportList));
